import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  WritableSignal
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'ngx-l2-change-table-col-btn',
  templateUrl: './l2-change-table-col-btn.component.html',
  styleUrls: ['./l2-change-table-col-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class L2ChangeTableColBtnComponent {

  readonly displayedColumns = input.required<WritableSignal<string[]>>();
  readonly possibleColumns = input.required<string[]>();
  readonly fixedColumns = input.required<string[]>();
  readonly category = input.required<string>();

  readonly columnTranslationMap = computed(() =>
    this.createColumnTranslationMap()
  );

  constructor(private translateService: TranslateService) {}

  private createColumnTranslationMap(): { [key: string]: string } {
    const obj: { [key: string]: string } = {};

    this.possibleColumns().forEach(column => {
      obj[column] = this.translateService.instant(
        this.category().toUpperCase() +
        '.TABLE_HEADERS.' +
        column.toUpperCase()
      );
    });

    return obj;
  }
}